<script setup lang="ts">
import type { PropType } from "vue";
import type { RouteLocationRaw } from "vue-router";

import AppLink from "@/components/AppLink.vue";
import PlainLayout from "@/layouts/PlainLayout.vue";

const props = defineProps({
  backTo: {
    type: [Object, String, null] as PropType<RouteLocationRaw>,
    default: null,
  },
  subtitle: { type: String as PropType<string>, default: undefined },
  title: { type: String as PropType<string>, default: undefined },
});
</script>

<template>
  <PlainLayout>
    <div class="flex min-h-screen flex-col bg-white pt-16 pb-12">
      <main class="mx-auto flex w-full max-w-7xl grow flex-col justify-center px-4 sm:px-6 lg:px-8">
        <div class="flex shrink-0 justify-center">
          <AppLink to="/" class="inline-flex">
            <span class="sr-only">Azerion Streaming</span>
            <img class="h-12 w-auto" src="/azerion-logo-black.png" />
          </AppLink>
        </div>
        <div class="py-16">
          <div class="text-center">
            <p class="text-blue-80 text-sm font-semibold uppercase tracking-wide">500 Error</p>
            <h1 class="text-grey-90 mt-2 text-4xl font-extrabold tracking-tight sm:text-5xl">
              {{ props.title ?? "Server Error." }}
            </h1>
            <p class="text-grey-500 mt-2 text-base">
              {{ props.subtitle ?? "Sorry, we encountered an unexpected error." }}
            </p>
            <div v-if="props.backTo" class="mt-6">
              <AppLink
                :to="props.backTo"
                class="text-blue-60 hover:text-blue-70 text-base font-medium"
              >
                Go back
                <span aria-hidden="true">&rarr;</span>
              </AppLink>
            </div>
          </div>
        </div>
      </main>
    </div>
  </PlainLayout>
</template>
